import React from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
import { SalesLetter } from '../components/SalesLetter';
import { WhatYouGet } from '../components/WhatYouGet';
import { BonusSection } from '../components/BonusSection';
import { WhatsAppTestimonials } from '../components/WhatsAppTestimonials';
import { PricingOffer } from '../components/PricingOffer';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <div style={{
    background: '#F6F1E7',
    minHeight: '100vh'
  }} data-id="element-350">
      <StickyAlertBar data-id="element-351" />
      <HeroSection data-id="element-352" />
      <SalesLetter data-id="element-353" />
      <WhatYouGet data-id="element-354" />
      <BonusSection data-id="element-355" />
      <WhatsAppTestimonials data-id="element-356" />
      <PricingOffer data-id="element-357" />
      <Testimonials data-id="element-358" />
      <FAQ data-id="element-359" />
      <FooterSection data-id="element-360" />
    </div>;
}